import * as React from "react";
import PropTypes from "prop-types";
import { useTheme } from "@mui/material/styles";
import AppBar from "@mui/material/AppBar";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import { categoryApi, addCategoryApi, updateCategoryApi } from "store/api";
import EditIcon from "@mui/icons-material/Edit";

import { Button, Grid, IconButton, MenuItem, Select, TextField, Tooltip } from "@mui/material";
import { Add, Delete, DeleteRounded, Edit, EditRounded, Search } from "@mui/icons-material";

import Card from "@mui/material/Card";
import CardActions from "@mui/material/CardActions";
import CardContent from "@mui/material/CardContent";
import CardMedia from "@mui/material/CardMedia";
import UpdateCategory from "../UpdateCategory";
import AddCategory from "../AddCategory";
import axios from "axios";
import Success from "components/Success";
import Link from "@mui/material/Link";
import Stack from "@mui/material/Stack";
import { Label } from "@mui/icons-material";
import Grid2 from "@mui/material/Unstable_Grid2";
import { deleteCategoryApi } from "store/api";
import { useNavigate } from "react-router-dom";
import { getAllSellCategoryApi } from "store/api";
import { addSellCategoryApi } from "store/api";
import { updateSellCategoryApi } from "store/api";

function TabPanel (props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role='tabpanel'
      hidden={value !== index}
      id={`full-width-tabpanel-${index}`}
      aria-labelledby={`full-width-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps (index) {
  return {
    id: `full-width-tab-${index}`,
    "aria-controls": `full-width-tabpanel-${index}`,
  };
}

export default function CategoryTab () {
  const navigate = useNavigate();
  const [msg, setMsg] = React.useState("");
  const [open, setOpen] = React.useState(false);
  const [success, setSuccess] = React.useState(false);
  const [openUpdate, setOpenUpdate] = React.useState(false);
  const [openAdd, setOpenAdd] = React.useState(false);
  const theme = useTheme();
  const [value, setValue] = React.useState(0);
  const [category, setCategory] = React.useState([]);
  const [updateCategory, setUpdateCategory] = React.useState({});
  const [addCategoryImage, setAddCategoryImage] = React.useState({});
  const [updateCategoryImage, setUpdateCategoryImage] = React.useState({});
  const [addCategory, setAddCategory] = React.useState({
    name: "",
    categoryOrder: 0,
  });
  const handleClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpen(false);
  };
  const handleClickOpenUpdate = data => {
    setUpdateCategory(data);
    setOpenUpdate(true);
  };
  const handleClickOpenAdd = () => {
    setOpenAdd(true);
  };

  const handleCloseUpdate = () => {
    setOpenUpdate(false);
    //   setOpen(true);
  };
  const handleCloseAdd = () => {
    setOpenAdd(false);
    //   setOpen(true);
  };

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const FetchCategory = async searchTerm => {
    const params = !searchTerm
      ? {}
      : {
          searchKeyword: searchTerm,
        };
    try {
      const response = await getAllSellCategoryApi(params);
      if (response?.success) {
        setCategory(response?.data);
      }
    } catch (err) {
      console.error(err);
    }
  };

  const [debounceTimeout, setDebounceTimeout] = React.useState(null);
  const handleChangeCategory = async e => {
    const { value } = e.target;
    // Clear the previous timeout
    if (debounceTimeout) clearTimeout(debounceTimeout);
    // Set a new timeout
    const newTimeout = setTimeout(() => {
      FetchCategory(value);
    }, 500); // Adjust debounce delay (500ms)

    setDebounceTimeout(newTimeout);
  };

  const handleSubmitUpdate = async e => {
    e?.preventDefault();
    const response = await updateSellCategoryApi(updateCategory);
    if (response?.success) {
      setMsg("Update Category Successfully");
      setSuccess(true);
      FetchCategory();
      setOpenUpdate(false);
      setOpen(true);
    } else {
      setMsg("Something went wrong. Please try again later.");
      setOpen(true);
      setOpenAdd(false);
      setSuccess(false);
    }
  };
  const handleSubmitAdd = async e => {
    e?.preventDefault();
    const response = await addSellCategoryApi(addCategory);
    if (response?.success) {
      setMsg("Add Category Successfully");
      setSuccess(true);
      setOpenAdd(false);
      FetchCategory();
    } else {
      setMsg("Something went wrong. Please try again later.");
      setOpen(true);
      setOpenAdd(false);
      setSuccess(false);
    }
  };
  const handleChangeUpdateCategory = e => {
    const { name, value } = e.target;
    setUpdateCategory(prev => ({
      ...prev,
      [name]: value,
    }));
  };
  const handleChangeAddCategory = e => {
    const { name, value } = e.target;
    setAddCategory(prev => ({
      ...prev,
      [name]: value,
    }));
  };

  const DeleteCategory = async categoryId => {
    const params = {
      categoryId: categoryId,
      isActive: false,
    };
    const response = await updateSellCategoryApi(params);
    if (response?.success) {
      setMsg("Delete Category Successfully");
      setSuccess(true);
      FetchCategory();
      setOpenAdd(false);
    } else {
      setSuccess(false);
      setMsg("Something went wrong. Please try again later.");
    }
    setOpen(true);
  };

  React.useEffect(() => {
    FetchCategory();
  }, []);

  return (
    <div
      style={{
        marginTop: "20px",
        marginBottom: "30px",
        backgroundColor: "",
        border: "",
        borderRadius: "12px",
        // boxShadow: "0 0 8px 1px rgba(0,0,0,0.25)",
        color: "",
        minHeight: "100vh",
      }}
    >
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          marginBottom: "20px",
          position: "absolute",
          top: "18px",
          right: "24px",
          gap: "8px",
        }}
      >
        <TextField
          placeholder='Search here...'
          InputProps={{
            endAdornment: (
              <IconButton color='inherit'>
                <Search />
              </IconButton>
            ),
          }}
          onChange={handleChangeCategory}
          style={{ backgroundColor: "", borderRadius: "4px" }}
        />
        <Button
          variant='contained'
          startIcon={<Add />}
          color='success'
          onClick={() => handleClickOpenAdd()}
          //   style={{ backgroundColor: "", color: "white", textTransform: "none" }}
        >
          Add New
        </Button>
      </div>

      {/* Search and Rows Per Page */}

      <Box>
        <Grid2 container py={3} spacing={3}>
          {category?.length == 0 && <div>No Category found</div>}
          {category?.length > 0 &&
            category?.map(e => (
              <Category
                category={e}
                DeleteCategory={DeleteCategory}
                handleClickOpenUpdate={handleClickOpenUpdate}
              />
            ))}
        </Grid2>
      </Box>
      <UpdateCategory
        open={openUpdate}
        handleClose={handleCloseUpdate}
        handleSubmit={handleSubmitUpdate}
        updateCategoryData={updateCategory}
        handleChangeUpdateCategory={handleChangeUpdateCategory}
      />
      <AddCategory
        open={openAdd}
        handleClose={handleCloseAdd}
        addCategoryData={addCategory}
        handleSubmit={handleSubmitAdd}
        handleChangeAddCategory={handleChangeAddCategory}
      />
      <Success open={open} success={success} msg={msg} handleClose={handleClose} />
    </div>
  );
}

const Category = ({ category, DeleteCategory, handleClickOpenUpdate }) => {
  const navigate = useNavigate();
  return (
    <Grid2 xs={12} sm={6} md={3} style={{ border: "16px", overflow: "hidden" }}>
      <Card style={{ position: "relative" }}>
        <div
          style={{
            zIndex: 9,
            top: 10,
            right: 10,
            position: "absolute",
            textTransform: "uppercase",
            display: "flex",
            gap: "10px",
          }}
        >
          <Tooltip title={"Delete"} onClick={() => DeleteCategory(category?.categoryId)}>
            <DeleteRounded style={{ fontSize: "16px", fill: "black", cursor: "pointer" }} />
          </Tooltip>
          <Tooltip title={"Edit"} onClick={() => handleClickOpenUpdate(category)}>
            {/* <IconButton > */}
            <EditRounded style={{ fontSize: "14px", fill: "black", cursor: "pointer" }} />
            {/* </IconButton> */}
          </Tooltip>
        </div>

        <Stack spacing={2} sx={{ py: 1, px: 2 }}>
          <Box
            color='inherit'
            underline='hover'
            variant='subtitle2'
            style={{ fontSize: "0.875rem", fontWeight: "500", cursor: "pointer", maxWidth: "95%" }}
            noWrap
            // onClick={() => navigate(`/sub-category?id=${category.categoryId}`)}
          >
            <div style={{ fontSize: "20px" }}>{category?.name}</div>
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                width: "100%",
                fontSize: "0.875rem",
              }}
            >
              <div>Order: {category?.categoryOrder}</div>
              <div>Active: {category.isActive ? "🟢" : "🔴"}</div>
            </div>
          </Box>
        </Stack>
      </Card>
    </Grid2>
  );
};
